export default __webpack_public_path__ + "d8adf31b6dbc65c3015a3ffd06bb2334.png";